export const TOOLTIP_CONTENT_CLASSNAME = 'tooltip-button__content';
export const ANIMATION_DURATION_IN_MS = 300;
